import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import { MinusSquare, PlusSquare, TickSquare } from './icons';
import Tree from './Tree';

const useStyles = makeStyles({
  root: {},
  view: {
    height: 264,
    minWidth: '80%',
    flexGrow: 1,
  },
});

const ApplicationView = ({ array, total }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TreeView
        className={classes.view}
        defaultExpanded={['-1']}
        defaultCollapseIcon={<MinusSquare />}
        defaultExpandIcon={<PlusSquare />}
        defaultEndIcon={<TickSquare />}
      >
        <Tree array={array} />
      </TreeView>
    </div>
  );
};

export default ApplicationView;
